import React from "react";
import "../css/AboutUs.css"; // Ensure you have the appropriate CSS file

const Pricing = () => {
  return (
    <div className="about-us">
      <h2>Pricing</h2>
      <p>
        To inquire about our pricing plans, please provide your <strong>Name</strong>, <strong>Email</strong>, and <strong>Mobile Number</strong>. You can send these details to <a href="mailto:sales@advisormitra.com">sales@advisormitra.com</a>.
      </p>
      <p><strong>Note:</strong></p>
      <ul>
        <li>Ensure that your email address and mobile number are valid.</li>
        <li>We use OTP-based validation for mobile numbers to prevent misuse of anyone else's number.</li>
      </ul>
      <p>
        Our sales team will get back to you with detailed information about our pricing options and how our platform can benefit your business.
      </p>
    </div>
  );
};

export default Pricing;